// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZiUdB","top":"styles_top__1Qo-3"};